export default __webpack_public_path__ + "static/media/day3.6d261d78.svg";